import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICampaignState } from '../../interfaces/state.interfaces';
import { ICampaignDetails } from '../../interfaces/campaign.interface';

const initialState: ICampaignState = {
    defaultCampaigns: [],
    brandCampaigns: [],
    selectedCampaign: null,
};

const campaignSlice = createSlice({
    name: 'campaign',
    initialState,
    reducers: {
        SetCampaigns(
            state,
            action: PayloadAction<{
                defaultCampaigns: ICampaignDetails[];
                brandCampaigns: ICampaignDetails[];
            }>,
        ) {
            state.defaultCampaigns = action.payload.defaultCampaigns;
            state.brandCampaigns = action.payload.brandCampaigns;
        },
        AddBrandCampaign(state, action: PayloadAction<ICampaignDetails>) {
            const exists = state.brandCampaigns.some((item) => item.id === action.payload.id);
            if (!exists) {
                state.brandCampaigns.push(action.payload);
            } else {
                state.brandCampaigns = state.brandCampaigns.map((item) => {
                    if (item.id === action.payload.id) {
                        return action.payload;
                    }
                    return item;
                });
            }
        },
        RemoveBrandCampaign(state, action: PayloadAction<string>) {
            state.brandCampaigns = state.brandCampaigns.filter(
                (campaign) => campaign.id !== action.payload,
            );
        },
        SetSelectedCampaign(state, action: PayloadAction<ICampaignDetails | null>) {
            state.selectedCampaign = action.payload;
        },
        SetCampaignsInitialState(state) {
            state.defaultCampaigns = [];
            state.brandCampaigns = [];
            state.selectedCampaign = null;
        },
    },
});

export const {
    SetCampaigns,
    AddBrandCampaign,
    RemoveBrandCampaign,
    SetSelectedCampaign,
    SetCampaignsInitialState,
} = campaignSlice.actions;

export const campaignReducer = campaignSlice.reducer;
